import GlobalFields from 'defs/ga/fields/global';
import SettingsFields from 'defs/ga/fields/settings';

export type TrackSettingsParams = {
	notificationService: string;
	notificationStatus: boolean;
};

export const trackSettingChange = ({ notificationService, notificationStatus }: TrackSettingsParams) => ({
	[GlobalFields.Event]: 'notifications',
	[SettingsFields.Service]: `${notificationService}`,
	[SettingsFields.Status]: !!notificationStatus ? 'enabled' : 'disabled',
});
